import { Component, input, InputSignal } from '@angular/core';
import { Icon, IconType } from '../icon/icon';

@Component({
  selector: 'app-progress-icon',
  imports: [Icon],
  host: {
    '[style.--percent]': 'percent()',
    '[style.width.rem]': 'size()',
    '[style.height.rem]': 'size()',
  },
  template: `
    <div class="progress" [style.width.rem]="size()" [style.height.rem]="size()">
      <svg [style.width.rem]="size()" [style.height.rem]="size()" viewBox="0 0 100 100">
        <circle class="circle-progress-background" cx="50" cy="50" r="43.6" fill="none" />
        <circle class="circle-progress" cx="50" cy="50" r="43.6" fill="none" />
      </svg>
      <app-icon [size]="size() * 0.7" [icon]="icon()" />
    </div>
  `,
  styleUrl: './progress-icon.scss',
})
export class ProgressIcon {
  icon: InputSignal<IconType> = input.required();
  size: InputSignal<number> = input.required<number>();
  percent: InputSignal<number> = input.required<number>();
}
